import ModuleBase from '@/components/general/ModuleBase';
import NovaLanding from '@/components/Nova/NovaLanding';
import { ModuleBaseModel, ModuleBasePropsModel } from '@/types';

type NovaLandingModuleModel = ModuleBaseModel<ModuleBasePropsModel>;

const NovaLandingModule = (data: NovaLandingModuleModel) => {
  return (
    <ModuleBase data={data} noPadding className="relative flex min-h-[calc(100dvh-var(--header-height))] flex-col">
      <NovaLanding />
    </ModuleBase>
  );
};

export default NovaLandingModule;
